import {useEffect,useState} from 'react';
import {ownerSalesDate} from '../../contracts/owner-sales-v1';

// Only display filters live in the URL; no session or business records are stored here.
export function useOwnerQueryState<T extends string>(key:string,fallback:T,parse:(raw:string|null)=>T){
  const read=()=>parse(new URLSearchParams(window.location.search).get(key));
  const [value,setValue]=useState<T>(read);
  useEffect(()=>{const restore=()=>setValue(read());window.addEventListener('popstate',restore);return()=>window.removeEventListener('popstate',restore);},[key]);
  useEffect(()=>{
    const url=new URL(window.location.href);
    if(value===fallback||!value)url.searchParams.delete(key);else url.searchParams.set(key,value);
    if(url.href!==window.location.href)window.history.replaceState(window.history.state,'',url.pathname+url.search+url.hash);
  },[key,value,fallback]);
  return [value,setValue] as const;
}
export const ownerQueryChoice=<T extends string>(choices:readonly T[],fallback:T)=>(raw:string|null):T=>choices.includes(raw as T)?raw as T:fallback;
export function ownerQueryDate(raw:string|null):string{
  return ownerSalesDate(raw)?raw:'';
}
